export default __webpack_public_path__ + "static/media/virtual-care-graphic.1c1acbfd.png";